<template>
  <article class="m-card-element m-card-element-design-7 m-card-primary m-card-transition">
    <img
      v-if="tarjeta.metadata.imagen"
      :alt="element.nombre"
      id="tarjetaImagen"
      :src="tarjeta.metadata.imagen"
    >
    <img
      v-else
      :alt="element.nombre"
      id="tarjetaImagen"
      src="@/assets/img/ds7.png"
    >

    <div class="m-card-element-info-data">
      <AtomListElementActionsSecondary
        v-if="!hideMoveIcon"
        :element="element"
      />
      <AtomListElementActionsPrimary
        :element="element"
      />

      <div
        v-if="showSelected && parseInt($route.params.subid) === 7"
        class="m-card-element-info-data-selected"
      >
        {{ $t('mFeedSectionContentCardDesing7.selected') }}
      </div>

      <h5
        v-if="element.categoria"
        key="categoryName"
      >
        {{ productoCategoriaNombre }}
      </h5>
      <h5
        v-else
        key="noCategoryName"
      >
        {{ $t('mFeedSectionContentCardDesing7.noCategoryName') }}
      </h5>

      <h2 class="m-card-element-design-7-name">
        {{ element.nombre }}
      </h2>
    </div>

    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="element.activo"
          key="available"
        >
         {{ $t('mFeedSectionContentCardDesing7.available') }}
        </h3>
        <h3
          v-else
          key="notAvailable"
        >
          {{ $t('mFeedSectionContentCardDesing7.notAvailable') }}
        </h3>
        <h4
          v-if="element.visible"
          key="visible"
        >
          {{ $t('mFeedSectionContentCardDesing7.visible') }}
        </h4>
        <h4
          v-else
          key="hidden"
        >
          {{ $t('mFeedSectionContentCardDesing7.hidden') }}
        </h4>
      </div>
      <router-link
        class="m-card-element-info-state-of-price-contrast"
        :to="`/${$t('rPaths.product')}/${element.id}/${$t('mEditionMenu.product.pricesAndPlans.subject')}`"
      >
        {{ productoPrecio }}
      </router-link>
    </div>
  </article>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentCardDesign7',

  props: {
    element: Object,
    elementCategorias: Array,
    hideMoveIcon: {
      type: Boolean,
      default: false
    },
    showSelected: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tarjeta: {
        tipo: 7,
        metadata: {
          imagen: ''
        }
      }
    }
  },

  computed: {
    productoCategoriaNombre () {
      return this.element.categoria.nombre !== undefined
        ? this.element.categoria.nombre
        : this.elementCategorias.find(categoria => categoria.id_producto_categoria === this.element.categoria.id_producto_categoria).nombre
    },

    productoPrecio () {
      return this.element.pago ? this.$t('mFeedSectionContentCardDesing7.price.buy') : this.$t('mFeedSectionContentCardDesing7.price.free')
    }
  },

  created () {
    if (this.element.tarjeta && this.element.tarjeta === 7) {
      this.tarjeta = Object.assign({}, { tipo: this.element.tarjeta, metadata: Object.assign({}, this.element.metadata) })
    }
  }
}
</script>
